import React from 'react';
import styles from './form-row.module.css';

interface FormRowProps {
    withMargin?: boolean;
    children: React.ReactNode;
}

function FormRow({ withMargin = true, children }: FormRowProps): React.ReactElement<FormRowProps> {
    return (
        <div className={styles.FormRow} style={{ margin: withMargin ? '0 0 1rem' : '0' }}>
            {children}
        </div>
    );
}

export default FormRow;
